import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "@/lib/api";

const InterviewDetailPage = () => {
  const { slug } = useParams();
  const [it, setIt] = useState(null);

  useEffect(() => {
    (async () => {
      try { setIt(await api.interview(slug)); } catch { setIt({ notFound: true }); }
    })();
  }, [slug]);

  if (!it) return <div className="min-h-[60vh] flex items-center justify-center text-ink-soft">Loading…</div>;
  if (it.notFound) return <div className="min-h-[60vh] flex items-center justify-center text-ink-soft">Interview not found.</div>;

  return (
    <article data-testid="interview-detail-page" className="pt-8 md:pt-14 pb-24">
      <div className="max-w-[1200px] mx-auto px-5 md:px-8">
        <Link to="/interviews" data-testid="interview-back-link" className="inline-flex items-center gap-2 text-ink-soft hover:text-ink text-[11px] font-mono-editorial uppercase tracking-[0.22em]">
          <ArrowLeft size={14} /> Back to Interviews
        </Link>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="aspect-[4/5] relative overflow-hidden border border-ink-line bg-cream">
              <img src={it.image} alt="" className="absolute inset-0 w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700" />
            </div>
          </div>
          <div className="lg:col-span-7">
            <div className="overline mb-4">Interview · {it.country}</div>
            <h1 className="font-display text-ink text-5xl md:text-6xl leading-[1.04]">{it.name}</h1>
            <div className="mt-4 text-ink-soft text-lg">{it.position} · {it.company}</div>
            <div className="hairline my-8" />
            <p className="text-ink-soft text-lg leading-relaxed">{it.summary}</p>
            <div className="mt-10 border border-dashed border-ink-line p-8">
              <div className="overline mb-3">Placeholder</div>
              <div className="font-display text-ink text-2xl md:text-3xl leading-tight">Full transcript arriving soon.</div>
              <p className="mt-4 text-ink-soft text-sm leading-relaxed">
                This interview slot is reserved. The full long-form conversation, portrait and pull quotes will be published once the subject and transcript are confirmed. All layout, typography and editorial framing remain in place — only the final text and portrait require replacement.
              </p>
            </div>
            <div className="mt-8 text-[11px] font-mono-editorial uppercase tracking-[0.18em] text-ink-muted">{it.read_time}</div>
          </div>
        </div>
      </div>
    </article>
  );
};

export default InterviewDetailPage;
